// extracted by mini-css-extract-plugin
export var container = "_qn-0";
export var dotAnimation = "_qn-2";
export var dotsLoading = "_qn-1";